export default "__VITE_ASSET__87aa424a__"